module.exports = __webpack_public_path__ + "media/wyposazenie/skrzynia-biegow@2x-eaf53bf8.png";